<template>
  <div class="home">
    facebook.com, 527377676179171, DIRECT, c3e20eee3f780d68
  </div>
</template>

<script>

export default {
  name: 'HomeRoute',
  components: {}
}
</script>
